export const getUmbracoEnv = () => {
    return ['dev', 'test'].includes(process.env.VUE_APP_ENV)
        ? 'https://test-nxl.nxfs.nexon.com'
        : 'https://nxl.nxfs.nexon.com';
};
